if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* Smart Gadgets (10-sep-2026): al cambiar de variante, sincronizar los modelos 3D de la galería
   aunque la variante no tenga foto propia (Dawn solo actualiza la galería cuando hay featured_media). */
(function () {
  /* Smart Gadgets (10-sep-2026): al cambiar de variante, Dawn reemplaza la galería y TODO el contenido
     del modal con el HTML recibido. Esos botones «Ver en tu espacio» llegan con data-shopify-xr-hidden y
     Dawn solo vuelve a llamar a ShopifyXR cuando se cambia de PRODUCTO (postProcessHtmlCallbacks), no
     cuando se cambia de VARIANTE. Resultado: el AR solo funcionaba en el primer color. Hay que
     reinicializarlo siempre, tenga o no foto propia la variante. */
  var reinitXR = function () {
    try {
      if (window.ProductModel && typeof window.ProductModel.loadShopifyXR === 'function') {
        window.ProductModel.loadShopifyXR();
      }
    } catch (e) { /* silencioso */ }
  };

  var syncModels = function (ev) {
    try {
      var d = ev && ev.data;
      if (!d || !d.html) return;
      /* Reinicializar el AR SIEMPRE, antes de cualquier otra condición. */
      reinitXR();
      setTimeout(reinitXR, 400);
      setTimeout(reinitXR, 1200);
      /* Si la variante tiene foto propia, Dawn ya actualizó la galería (y movió los nodos del HTML recibido): no tocar. */
      if (d.variant && d.variant.featured_media && d.variant.featured_media.id) return;
      var pi = document.querySelector('product-info[data-section="' + d.sectionId + '"]') || document.querySelector('product-info');
      var g = pi ? pi.querySelector('media-gallery') : null;
      var src = d.html.querySelector('media-gallery ul');
      if (!g || !src) return;
      var ul = g.querySelector('[id^="Slider-Gallery"]');
      if (!ul) return;
      var want = {}, order = [];
      src.querySelectorAll('li[data-media-id]').forEach(function (li) {
        if (li.querySelector('product-model')) { want[li.dataset.mediaId] = li; order.push(li.dataset.mediaId); }
      });
      var have = {}, changed = false, lostActive = false;
      ul.querySelectorAll('li[data-media-id]').forEach(function (li) {
        if (!li.querySelector('product-model')) return;
        if (want[li.dataset.mediaId]) { have[li.dataset.mediaId] = 1; return; }
        if (li.classList.contains('is-active')) lostActive = true;
        li.remove(); changed = true;
      });
      order.forEach(function (id) {
        if (have[id]) return;
        var node = document.importNode(want[id], true);
        node.classList.remove('is-active');
        node.classList.add('scroll-trigger--cancel');
        ul.appendChild(node); changed = true;
      });
      if (!changed) return;
      if (lostActive) {
        var first = ul.querySelector('li[data-media-id]');
        if (first && typeof g.setActiveMedia === 'function') g.setActiveMedia(first.dataset.mediaId, false);
      }
      reinitXR();
    } catch (e) { /* silencioso */ }
  };
  var bind = function () { if (typeof subscribe === 'function') subscribe('variant-change', syncModels); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
